module.exports = __webpack_public_path__ + "static/media/hangout.f9f8369d.wav";